import React, { FC } from 'react';

import IframeForm from '../../Common/IframeForm';
import PDFViewer, { PDFViewerPublicProps } from '../PDFViewer';
import PdfTileViewer from '../PdfTileViewer';
import { IframeParams } from '../interfaces';
import {
    OfficeViewerResponse, FileAccessResponse, PdfViewerResponse, PdfViewerSession,
} from '../../../types/types';
import styles from './OpenWidget.module.scss';

interface OpenWidgetProps extends PDFViewerPublicProps {
    iframeParams: IframeParams;
    onSessionExpired?: () => void;
    onRefreshSession?: () => Promise<PdfViewerSession>;
}

const OpenWidget: FC<OpenWidgetProps> = ({
    iframeParams,
    PDFViewerStyle,
    onSessionExpired,
    onRefreshSession,
    ...rest
}) => {
    const pdfViewerSession = (iframeParams as PdfViewerResponse)?.pdfViewer;
    const pdfViewerKey = (iframeParams as FileAccessResponse)?.link || 'no-pdf';
    return (
        <div className={styles['viewer-wrapper']}>
            {(iframeParams as OfficeViewerResponse)?.viewUrl && (
                <IframeForm
                    name="office_frame"
                    config={{
                        url: (iframeParams as OfficeViewerResponse).viewUrl,
                        method: 'post',
                        data: {
                            access_token: (iframeParams as OfficeViewerResponse).accessToken,
                            access_token_ttl: (iframeParams as OfficeViewerResponse).accessTokenTtl,
                        },
                    }}
                    style={PDFViewerStyle}
                />
            )}
            {pdfViewerSession && (
                <PdfTileViewer
                    key={pdfViewerSession.documentId}
                    session={pdfViewerSession}
                    filePolicyId={rest.filePolicyId}
                    setIsLoading={rest.setIsLoading}
                    carouselMode={rest.carouselMode}
                    PDFViewerClassName={rest.PDFViewerClassName}
                    PDFViewerStyle={PDFViewerStyle}
                    onSessionExpired={onSessionExpired}
                    onRefreshSession={onRefreshSession}
                />
            )}
            {(iframeParams as FileAccessResponse)?.link && (
                <PDFViewer
                    key={pdfViewerKey}
                    documentUrl={(iframeParams as FileAccessResponse).link}
                    PDFViewerStyle={PDFViewerStyle}
                    {...rest}
                />
            )}
        </div>
    );
};

export default OpenWidget;
